import Api from './Api';

import { ActorModel } from '@/model';
import { ApiConnectorInstance } from '@/Singletons';

class _StorageApi extends Api {
    constructor() {
        super();
    }

    uploadActorFile(file: any, name: string, actor: ActorModel, folder: string): Promise<any> {
        if (!actor) throw new Error('Provide actor for file upload');
        if (!folder) throw new Error('Provide folder param for actor file upload');

        const formData = new FormData();
        formData.append('file', file, name);

        // TODO: storage is unprotected
        return ApiConnectorInstance.getHttpClient('storage', false).post(
            `/Actors/${actor.cislo_hlasu}/${folder}`,
            formData
        );
    }

    loadActorFile(file_url: string): Promise<any> {
        // TODO: storage is unprotected
        return ApiConnectorInstance.getHttpClient('storage', false).get(file_url);
    }
}

export const StorageApi = new _StorageApi();
